const loopThroughInstances = (callback) => {

    let instances  = document.getElementsByClassName("cart-progress-bar");
    for (let i = 0; i < instances.length; i++) {
        let instance = instances[i];
        callback(instance)
    }
}

const formatMoney = (cents, format) => {
    if (typeof cents == 'string') { cents = cents.replace('.',''); }
    let value = '';
    let placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    let formatString = (format || "${{amount_no_decimals}}");

    function defaultOption(opt, def) {
        return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ',');
        decimal   = defaultOption(decimal, '.');

        if (isNaN(number) || number == null) { return 0; }

        number = (number/100.0).toFixed(precision);

        var parts   = number.split('.'),
            dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
            cents   = parts[1] ? (decimal + parts[1]) : '';

        return dollars + cents;
    }

    switch(formatString.match(placeholderRegex)[1]) {
        case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
        case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
        case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
        case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
    }

    return formatString.replace(placeholderRegex, value);
}

const formatCurrency = (currencyFormat, amount) => {
    let formattedAmount = '';
    formattedAmount = currencyFormat
        .replace('{{amount}}', amount.toFixed(2)) // Standard with two decimals
        .replace('{{amount_no_decimals}}', amount.toFixed(0)) // No decimals
        .replace('{{amount_with_comma_separator}}', amount.toFixed(2).replace('.', ',')) // Replace period with comma
        .replace('{{amount_no_decimals_with_comma_separator}}', amount.toFixed(0).replace('.', ',')) // No decimals, use comma
        .replace('{{amount_with_apostrophe_separator}}', amount.toFixed(2).replace('.', "'")) // Apostrophe separator
        .replace('{{amount_no_decimals_with_space_separator}}', amount.toFixed(0).replace(/\\B(?=(\\d{3})+(?!\\d))/g, ' ')) // No decimals, space
        .replace('{{amount_with_space_separator}}', amount.toFixed(2).replace(/\\B(?=(\\d{3})+(?!\\d))/g, ' ').replace('.', ',')) // Space separator
        .replace('{{amount_with_period_and_space_separator}}', amount.toFixed(2).replace(/\\B(?=(\\d{3})+(?!\\d))/g, ' ')); // Period and space
    return formattedAmount;
}

const isFrameProduct = (item = {}) => {
    const productType = (item.product_type || '').toLowerCase();
    const handle = (item.handle || '').toLowerCase();
    const title = (item.product_title || item.title || '').toLowerCase();

    return productType.includes('frame') || handle.includes('frame') || title.includes('frame');
}

const getNonFrameItemCount = (cart = {}) => {
    if (!Array.isArray(cart.items)) {
        return 0;
    }

    return cart.items.reduce((count, item) => {
        return isFrameProduct(item) ? count : count + (item.quantity || 0);
    }, 0);
}

const convertItemsToPrints = (text = '') => {
    // Keep messages consistent with frames being excluded from counts.
    const swapped = text
        .replace(/items/gi, 'prints')
        .replace(/item/gi, 'print');

    // Fix singular cases: "1 prints" -> "1 print" (including "1 FREE prints").
    return swapped.replace(/\b1\s+([A-Za-z]*\s*)?prints\b/gi, (_match, freePart) => {
        const prefix = freePart || '';
        return `1 ${prefix}print`;
    });
}


const collectionHandleCache = new Map();
const collectionStoragePrefix = 'pp-buyxgety-collection-';

const getStoredHandles = (collectionHandle) => {
    try {
        const raw = sessionStorage.getItem(`${collectionStoragePrefix}${collectionHandle}`);
        if (!raw) {
            return null;
        }
        const parsed = JSON.parse(raw);
        if (!Array.isArray(parsed)) {
            return null;
        }
        return new Set(parsed);
    } catch (_error) {
        return null;
    }
}

const storeHandles = (collectionHandle, handles) => {
    try {
        sessionStorage.setItem(
            `${collectionStoragePrefix}${collectionHandle}`,
            JSON.stringify(Array.from(handles))
        );
    } catch (_error) {
        // Ignore storage failures (private mode, quota, etc.).
    }
}

const fetchCollectionProductHandles = (collectionHandle) => {
    if (collectionHandleCache.has(collectionHandle)) {
        return collectionHandleCache.get(collectionHandle);
    }

    const storedHandles = getStoredHandles(collectionHandle);
    if (storedHandles) {
        const storedPromise = Promise.resolve(storedHandles);
        collectionHandleCache.set(collectionHandle, storedPromise);
        return storedPromise;
    }

    const request = (async () => {
        const handles = new Set();
        const maxPages = 2;
        const limit = 250;

        for (let page = 1; page <= maxPages; page += 1) {
            const response = await fetch(`/collections/${collectionHandle}/products.json?limit=${limit}&page=${page}`);
            if (!response.ok) {
                break;
            }

            const data = await response.json();
            if (Array.isArray(data.products)) {
                data.products.forEach((product) => {
                    if (product && product.handle) {
                        handles.add(product.handle);
                    }
                });
            }

            if (!data.products || data.products.length < limit) {
                break;
            }
        }

        if (handles.size > 0) {
            storeHandles(collectionHandle, handles);
            return handles;
        }
        return null;
    })().catch(() => null);

    collectionHandleCache.set(collectionHandle, request);
    return request;
}

const getEligibleItemCount = async (cart = {}, instance) => {
    if (!Array.isArray(cart.items) || !instance) {
        return 0;
    }

    const collectionHandle = (instance.dataset.buyXGetYCollection || '').trim();
    if (!collectionHandle) {
        return getNonFrameItemCount(cart);
    }

    const storedHandles = getStoredHandles(collectionHandle);
    if (storedHandles) {
        return cart.items.reduce((count, item) => {
            return storedHandles.has(item.handle) ? count + (item.quantity || 0) : count;
        }, 0);
    }

    const handles = await fetchCollectionProductHandles(collectionHandle);
    if (!handles) {
        return getNonFrameItemCount(cart);
    }

    return cart.items.reduce((count, item) => {
        return handles.has(item.handle) ? count + (item.quantity || 0) : count;
    }, 0);
}

const replaceTemplateToken = (template = '', token = '', value = '') => {
    if (!template || !token) {
        return template;
    }
    const escapedToken = token.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
    return template.replace(new RegExp(`\\[${escapedToken}\\]`, 'g'), value);
}

const updateProgressBarForInstance = (instance, cartTotal, itemCount) => {
    const sectionId = instance.dataset.sectionId
    const progressWrapper = document.getElementById(`cart-progress-wrapper-${sectionId}`);

        const currencyFormat = progressWrapper.dataset.currencyFormat;
        const progressThreshold = parseInt(progressWrapper.dataset.threshold, 10);
        const preGoalMessageTemplate = progressWrapper.dataset.preGoalMessageTemplate;
        const midGoalMessageTemplate = progressWrapper.dataset.midGoalMessageTemplate;
        const buyXGetYMessageTemplate = progressWrapper.dataset.buyXGetYMessageTemplate;
        const buyXGetYMessageFirstTemplate = progressWrapper.dataset.buyXGetYMessageFirstTemplate;
        const buyXGetYMessageSecondTemplate = progressWrapper.dataset.buyXGetYMessageSecondTemplate;
        const buyXGetYMessageProgressTemplate = progressWrapper.dataset.buyXGetYMessageProgressTemplate;
        const postGoalMessage = progressWrapper.dataset.postGoalMessage;

        const progressBar = document.getElementById(`cart-progress-bar-${sectionId}`);
        const goalMessageElement = document.getElementById(`goal-message-${sectionId}`);

        if (itemCount === 0 || cartTotal === 0) {
            if (progressWrapper) {
                progressWrapper.style.display = 'none';
            }
            if (goalMessageElement) {
                goalMessageElement.style.display = 'none';
            }
        } else {
            if (progressWrapper) {
                progressWrapper.style.display = 'block';
            }

            const progressPercentage = Math.min((cartTotal / progressThreshold) * 100, 100);
            if (progressBar) {
                progressBar.style.display = 'block';
                progressBar.style.width = `${progressPercentage}%`;

                if (progressPercentage >= 100) {
                    progressWrapper.classList.add('full');
                } else {
                    progressWrapper.classList.remove('full');
                }
            }

            if (goalMessageElement) {
                goalMessageElement.style.display = 'block';
                let remainingForGoal = progressThreshold - cartTotal;

                if (remainingForGoal < 0) {
                    remainingForGoal = 0;
                }

                const remainingAmount = remainingForGoal / 100;
                const remainingAmountFormatted = formatCurrency(currencyFormat, remainingAmount);
                const preGoalMessage = preGoalMessageTemplate.replace('[remaining_for_goal]', remainingAmountFormatted);
                const midGoalMessage = midGoalMessageTemplate.replace('[remaining_for_goal]', remainingAmountFormatted);

                let buyXGetYMessage;
                if (buyXGetYMessageTemplate || buyXGetYMessageFirstTemplate || buyXGetYMessageSecondTemplate || buyXGetYMessageProgressTemplate) {
                    var buyMinimum = Number(instance.dataset.minimum) || 0;
                    var buyFree = Number(instance.dataset.free) || 0;
                    if (buyMinimum > 0 && buyFree > 0) {
                        var cycleSize = buyMinimum + buyFree;
                        var currentCycles = Math.floor(itemCount / cycleSize);
                        var currentFree = currentCycles * buyFree;
                        var cyclesTarget = Math.max(1, Math.ceil((itemCount + 1) / cycleSize));
                        var nextThreshold = cyclesTarget * cycleSize;
                        var itemsNeeded = Math.max(nextThreshold - itemCount, 0);
                        var freeAtThreshold = cyclesTarget * buyFree;
                        if (buyXGetYMessageFirstTemplate && buyXGetYMessageSecondTemplate && buyXGetYMessageProgressTemplate) {
                            if (currentFree === 0 && itemsNeeded === 1) {
                                buyXGetYMessage = replaceTemplateToken(buyXGetYMessageSecondTemplate, 'items_needed', itemsNeeded);
                                buyXGetYMessage = replaceTemplateToken(buyXGetYMessage, 'next_free', freeAtThreshold);
                            } else if (currentFree === 0) {
                                buyXGetYMessage = replaceTemplateToken(buyXGetYMessageFirstTemplate, 'items_needed', itemsNeeded);
                                buyXGetYMessage = replaceTemplateToken(buyXGetYMessage, 'next_free', freeAtThreshold);
                            } else {
                                buyXGetYMessage = replaceTemplateToken(buyXGetYMessageProgressTemplate, 'current_free', currentFree);
                                buyXGetYMessage = replaceTemplateToken(buyXGetYMessage, 'items_needed', itemsNeeded);
                                buyXGetYMessage = replaceTemplateToken(buyXGetYMessage, 'next_free', freeAtThreshold);
                            }
                        } else if (buyXGetYMessageTemplate) {
                            buyXGetYMessage = buyXGetYMessageTemplate.replace('[buy_x_get_y_minimum]', 'another ' + itemsNeeded);
                            buyXGetYMessage = buyXGetYMessage.replace('[buy_x_get_y_free]', freeAtThreshold);
                            buyXGetYMessage = buyXGetYMessage.replace(/another 1 items/gi, 'another 1 print');
                            buyXGetYMessage = buyXGetYMessage.replace(/1\s+FREE\s+items/gi, '1 FREE print');
                            buyXGetYMessage = convertItemsToPrints(buyXGetYMessage);
                        }
                    }
                }

                const extraNode = goalMessageElement.querySelector('[data-goal-extra]');
                const mainNode = goalMessageElement.querySelector('[data-goal-main]');
                if (extraNode) {
                    extraNode.innerHTML = '';
                }
                let selectedMessaged = preGoalMessage
                if (progressPercentage >= 100) {
                    selectedMessaged = postGoalMessage

                }
                else if (progressPercentage >= 50 && progressPercentage < 100) {
                    selectedMessaged = midGoalMessage

                } else {

                    if (buyXGetYMessage) {
                        selectedMessaged = buyXGetYMessage;
                    }
                    else {
                        selectedMessaged = preGoalMessage;
                    }
                }

                if (mainNode) {
                    mainNode.innerHTML = selectedMessaged;
                }
                if (progressPercentage >= 100 && buyXGetYMessage && extraNode) {
                    extraNode.innerHTML = buyXGetYMessage;
                    goalMessageElement.classList.add('goal-message--stacked');
                } else if (extraNode) {
                    extraNode.innerHTML = '';
                    goalMessageElement.classList.remove('goal-message--stacked');
                }
            }
        }
}

const update = async (cart) => {
    loopThroughInstances(async (instance) => {
        const eligibleCount = await getEligibleItemCount(cart, instance);
        updateProgressBarForInstance(instance, cart.total_price, eligibleCount);
    });
}

const getCart = () => {
    return fetch('/cart.js')
        .then(res=>res.json())
}

const setup = (instance) => {

    class CartProgressBar {
        constructor(cartProgressBar = { selector: '#cart-progress-wrapper', events: [], placeholder: '(x)' }) {

            if (cartProgressBar.selector && typeof cartProgressBar.selector == 'string' && cartProgressBar.selector !== '') {
                this.selector = cartProgressBar.selector;
            } else {
                throw new TypeError("Please pass a valid selector");
            }

            this.cpbElement = document.querySelector(this.selector);
            if(!this.cpbElement) {
                throw new TypeError("Cart Progress Bar Element Not Found");
            }

            this.events = cartProgressBar.events;
            this.placeholder = cartProgressBar.placeholder;
        }
    }

    let sectionId = instance.dataset.sectionId;
    new CartProgressBar({
        selector: `#cart-progress-wrapper-${sectionId}`, // Selector of the HTML template (Snippet)
        events: ['cpb:refresh-cart-progress-bar'], //Events used to update the FSB
        placeholder: '(x)' //Placeholder character to replace the goal/remaining amount in the FSB headline
    });
}

const domContentLoaded = () => {

    loopThroughInstances(setup)
    loopThroughInstances((instance) => {
        const collectionHandle = (instance.dataset.buyXGetYCollection || '').trim();
        if (collectionHandle) {
            fetchCollectionProductHandles(collectionHandle).then((handles) => {
                if (handles) {
                    document.dispatchEvent(new CustomEvent('cpb:refresh-cart-progress-bar'));
                }
            });
        }
    });

    document.addEventListener("cpb:refresh-cart-progress-bar", e => {
        getCart().then(cart => update(cart))
    }, true);
}

window.addEventListener('DOMContentLoaded', domContentLoaded);
